const appName = process.env.VUE_APP_NAME;

/**
 * 英语
 */
export default {
  route: {
    dashboard: {
      _name: 'Dashboard',
      workplace: { _name: 'home' },
    },
    recharge: {
      _name: 'recharge',
    },
    settlement: {
      _name: 'withdraw',
    },
    transaction: {
      _name: 'table page',
      inorder: { _name: 'Receiving orders' },
      outorder: { _name: 'Disbursement orders' },
      records: { _name: 'Transaction changes' },
    },
    reconciliation: {
      bussiness: { _name: 'Statistical reports' },
    },
    user: {
      _name: 'User',
      profile: { _name: 'Security settings' },
      message: { _name: 'Message' }
    },
  },
  layout: {
    home: 'Home',
    header: {
      profile: 'Profile',
      password: 'Password',
      logout: 'SignOut'
    },
    footer: {
      website: 'Website',
      document: 'Document',
      authorization: 'Authorization',
      copyright: 'Copyright © 2021 NanJing RXThinkCMF R & D Center'
    },
    logout: {
      title: 'Confirm',
      message: 'Are you sure you want to log out?'
    }
  },
  login: {
    title: appName,
    tip: 'Please enter your username and password to log in.',
    username: 'Please enter your username',
    password: 'Please enter your password',
    captcha: 'Please enter the verification code',
    remember: 'Remember me',
    forget: 'Forgot password?',
    login: 'Log In',
    loading: 'Logging in...'
  },
  home: {
    accountOverview: 'Account Overview',
    realtimeFunds: 'Realtime Funds',
    totalAmount: 'Total Amount',
    availableBalance: 'Available Balance',
    frozenAmount: 'Frozen Amount',
    unsettledBalance: 'Unsettled Balance'
  }
}
